/** Year in the AMA CPT copyright notice. Update it here once a year; every notice reads it. */
export const CPT_COPYRIGHT_YEAR = 2026;

/** The AMA copyright notice shown wherever CPT codes appear on screen, in PDFs and in exports. */
export const CPT_COPYRIGHT_NOTICE = `CPT® copyright ${CPT_COPYRIGHT_YEAR} American Medical Association. All rights reserved.`;
